import React, { Component, createRef } from 'react';
import { Input, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './UserManage.scss';

import commonConstant from '../../common/_commonConstant';
import {
  Modal,
  Dropdown,
  validateAlpha,
  validateEmail,
  validateNumber,
  validateTelNumber,
  validateUsername,
  buildingID,
} from '../../helpers';
import { Loading } from '../../components';
import {
  fetchGetUserRoles,
  fetchCreateUser,
  clearCreateUser,
  fetchUpdateUser,
  fetchResetUserPassword,
  clearResetUserPassword,
} from '../../actions';


class UserManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'success': false,
      'userRole': null,
      'name': '',
      'userEmail': null,
      'mobilePhone': '',
      'username': '',
      'userRoleID': '',
      'nameError': false,
      'userEmailError': false,
      'mobilePhoneError': false,
      'usernameError': false,
      'usernameExist': false,
      'userRoleError': false,
      'userRoleOperation': null,
      'userRoleAccounting': null,
      'userRoleCashier': null,
      'userRoles': null,
      'userDeletedAt': null,
      'resetPassword': false,
    };
    this.dropdown = createRef();
    props.dispatch(fetchGetUserRoles());
  }

  componentDidMount() {
    const { userEdit, action } = this.props;
    if (userEdit && action === commonConstant.userManagementEdit) {
      return this.setState({
        'name': JSON.parse(userEdit.userProfile).name, 'userRole': userEdit.userRole.userRoleCode,
        'userRoleID': userEdit.userRole.userRoleID, 'userEmail': userEdit.userEmail,
        'mobilePhone': JSON.parse(userEdit.userProfile).mobilePhone, 'username': userEdit.userName,
        'userDeletedAt': userEdit.deletedAt,
      });
    } else if (userEdit && action === commonConstant.userManagementReset) {
      return this.setState({ 'name': JSON.parse(userEdit.userProfile).name, 'username': userEdit.userName, 'userRoleID': userEdit.userRole.userRoleID });
    }
  }

  componentDidUpdate(prevProps) {
    const { createUser, updateUser, resetUserPassword } = this.props;
    const { userRoleAccounting, userRoleCashier, userRoleOperation, userRoles } = this.state;

    if (!userRoleAccounting && !userRoleCashier && !userRoleOperation && !userRoles) {
      this.handleUserRoleSelecter();
    }

    if (createUser.status === 200 && createUser.data !== prevProps.createUser.data && createUser.type === commonConstant.CREATE_USER_SUCCESS) {
      return this.setState({ 'success': true });
    } else if (createUser.status === 400 && createUser.data.reason) {
      if (createUser.data.reason === commonConstant.userManagementUsernameExist) {
        this.setState({ 'usernameExist': true });
        return this.props.dispatch(clearCreateUser());
      }
    } else if (updateUser.status === 200 && updateUser.data !== prevProps.updateUser.data && updateUser.type === commonConstant.UPDATE_USER_SUCCESS) {
      return this.handleClearState();
    } else if (resetUserPassword.status === 200 && resetUserPassword.data !== prevProps.resetUserPassword.data && resetUserPassword.type === commonConstant.RESET_USER_PASSWORD_SUCCESS) {
      return this.setState({ 'success': true, 'resetPassword': true });
    } else if (resetUserPassword.status === 400 && resetUserPassword.data !== prevProps.resetUserPassword.data && resetUserPassword.type === commonConstant.RESET_USER_PASSWORD_FAILURE) {
      return this.setState({ 'success': false, 'resetPassword': true });
    }
  }

  handleHeaderModal = () => {
    const { action } = this.props;

    if (!action) {
      return null;
    }

    switch (action) {
      case commonConstant.userManagementCreate:
        return 'เพิ่มผู้ใช้งาน';
      case commonConstant.userManagementEdit:
        return 'แก้ไขข้อมูลผู้ใช้งาน';
      case commonConstant.userManagementReset:
        return 'ตั้งรหัสผ่านใหม่';
      case commonConstant.userManagementDelete:
        return 'ลบผู้ใช้งาน';
      default:
        return null;
    }
  }

  handleValueShow = () => {
    const { userRole } = this.state;

    switch (userRole) {
      case commonConstant.userRoleOperation:
        return 'Operation';
      case commonConstant.userRoleCashier:
        return 'Cashier';
      case commonConstant.userRoleAccounting:
        return 'Accounting';
      default:
        return null;
    }
  }

  handleUserRoleSelecter = () => {
    const { getUserRoles } = this.props;
    const obj = {};

    if (getUserRoles) {
      return getUserRoles.forEach((userRoles, index) => {
        if (userRoles.userRoleCode === commonConstant.userRoleAccounting) {
          obj[`${userRoles.userRoleID}`] = userRoles.userRoleName;
          this.setState({
            'userRoleAccounting': {
              'userRoleID': userRoles.userRoleID, 'userRoleName': userRoles.userRoleName,
              'userRoleCode': userRoles.userRoleCode,
            },
          });
        } else if (userRoles.userRoleCode === commonConstant.userRoleOperation) {
          obj[`${userRoles.userRoleID}`] = userRoles.userRoleName;
          this.setState({
            'userRoleOperation': {
              'userRoleID': userRoles.userRoleID, 'userRoleName': userRoles.userRoleName,
              'userRoleCode': userRoles.userRoleCode,
            },
          });
        } else if (userRoles.userRoleCode === commonConstant.userRoleCashier) {
          obj[`${userRoles.userRoleID}`] = userRoles.userRoleName;
          this.setState({
            'userRoleCashier': {
              'userRoleID': userRoles.userRoleID, 'userRoleName': userRoles.userRoleName,
              'userRoleCode': userRoles.userRoleCode,
            },
          });
        }
        if (getUserRoles.length === index + 1) {
          return this.setState({ 'userRoles': obj });
        }
      });
    }
  }

  handleResetUserPassword = userID => userID ? this.props.dispatch(fetchResetUserPassword(userID)) : null

  handleBodyModal = () => {
    const { action, handleCloseModal, userEdit } = this.props;
    const {
      name,
      mobilePhone,
      nameError,
      mobilePhoneError,
      userEmailError,
      username,
      usernameError,
      userRoleError,
      userRole,
      userRoleID,
      userRoleOperation,
      userRoleCashier,
      userRoleAccounting,
      userRoles,
      usernameExist,
      userEmail,
      userDeletedAt,
    } = this.state;

    if (!userRoles) {
      return <Loading />;
    }

    switch (action) {
      case commonConstant.userManagementCreate:
        return (
          <div className="user-manage-box">
            <div className="user-manage-title">ชื่อ-สกุล</div>
            <Input
              className="user-manage-input"
              placeholder="กรอกชื่อ และนามสกุล"
              onChange={event => this.handleState('name', event.target.value)}
              value={name}
              id="user-manage-name-surname"
            />
            {nameError ? this.handleErrorMessage('กรุณาระบุชื่อ - สกุล') : null}
            <div className="user-manage-title">ประเภทผู้ใช้งาน</div>
            <div className="user-manage-select">
              <Dropdown
                id="select-user-type"
                template="a"
                placeholder="เลือกประเภทผู้ใช้งาน"
                valueShow={this.handleValueShow()}
                ref={this.dropdown}
              >
                <div
                  className={`item${userRole === commonConstant.userRoleOperation ? ' active' : ''}`}
                  onClick={() => this.handleState('userRole', userRoleOperation.userRoleCode, userRoleOperation.userRoleID)}
                  id="user-manage-role-operation"
                >
                  {userRoleOperation.userRoleName}
                </div>
                <div
                  className={`item${userRole === commonConstant.userRoleCashier ? ' active' : ''}`}
                  onClick={() => this.handleState('userRole', userRoleCashier.userRoleCode, userRoleCashier.userRoleID)}
                  id="user-manage-role-cashier"
                >
                  {userRoleCashier.userRoleName}
                </div>
                <div
                  className={`item${userRole === commonConstant.userRoleAccounting ? ' active' : ''}`}
                  onClick={() => this.handleState('userRole', userRoleAccounting.userRoleCode, userRoleAccounting.userRoleID)}
                  id="user-manage-role-accounting"
                >
                  {userRoleAccounting.userRoleName}
                </div>
              </Dropdown>
              {userRoleError ? this.handleErrorMessage('กรุณาระบุประเภทผู้ใช้งาน') : null}
            </div>
            <div className="user-manage-title">Email (Optional)</div>
            <Input
              className="user-manage-input" placeholder="ระบุอีเมล (หากมี)"
              onChange={event => this.handleState('userEmail', event.target.value)}
              id="user-manage-email"
            />
            {userEmailError ? this.handleErrorMessage('รูปแบบ email ไม่ถูกต้อง') : null}
            <div className="user-manage-title">เบอร์มือถือ</div>
            <Input
              className="user-manage-input"
              placeholder="ระบุเบอร์ติดต่อ ในรูปแบบ 0812345678"
              onChange={event => this.handleValidateNumber('mobilePhone', event.target.value)}
              onBlur={event => this.handleState('mobilePhone', event.target.value)}
              value={mobilePhone}
              maxLength={10}
              id="user-manage-mobile-phone"
            />
            {mobilePhoneError ? this.handleErrorMessage('กรุณาระบุเบอร์โทร 10 หลัก ในรูปแบบ 08,09,06 เป็นต้น') : null}
            <div className="user-manage-title">ชื่อผู้ใช้งาน / Username</div>
            <Input
              className="user-manage-input"
              placeholder="ระบุชื่อผู้ใช้งาน ขั้นต่ำ 5 ตัวอักษร"
              onChange={event => this.handleState('username', event.target.value)}
              value={username}
              id="user-manage-username"
            />
            {usernameError ? this.handleErrorMessage('กรุณาระบุขั้นต่ำ 5 ตัวอักษร') : null}
            {usernameExist ? this.handleErrorMessage('ชื่อผู้ใช้ซ้ำ กรุณาใช้ชื่อผู้ใช้อื่น') : null}
            <div className="user-manage-button-box">
              <Button
                className="btn-primary btn-user"
                onClick={() => this.handleConfirm(commonConstant.userManagementCreate)}
                id="user-manage-create-btn"
              >บันทึก</Button>
            </div>
          </div>
        );
      case commonConstant.userManagementEdit:
        return (
          <div className="user-manage-box">
            <div className="user-manage-title">ชื่อ-สกุล</div>
            <Input
              className="user-manage-input"
              placeholder="กรอกชื่อ และนามสกุล"
              onChange={event => this.handleState('name', event.target.value)}
              value={name}
              id="user-manage-name-surname"
            />
            {nameError ? this.handleErrorMessage('กรุณาระบุชื่อ - สกุล') : null}
            <div className="user-manage-title">ประเภทผู้ใช้งาน</div>
            <div className="user-manage-select">
              <Dropdown
                template="a"
                placeholder="เลือกประเภทผู้ใช้งาน"
                valueShow={this.handleValueShow()}
                readOnly
              >
                <div
                  className={`item${userRole === commonConstant.userRoleOperation ? ' active' : ''}`}
                >
                  {userRoleOperation.userRoleName}
                </div>
                <div
                  className={`item${userRole === commonConstant.userRoleCashier ? ' active' : ''}`}
                >
                  {userRoleCashier.userRoleName}
                </div>
                <div
                  className={`item${userRole === commonConstant.userRoleAccounting ? ' active' : ''}`}
                >
                  {userRoleAccounting.userRoleName}
                </div>
              </Dropdown>
            </div>
            <div className="user-manage-title">Email (Optional)</div>
            <Input
              className="user-manage-input" placeholder="ระบุอีเมล (หากมี)"
              onChange={event => this.handleState('userEmail', event.target.value)}
              value={userEmail}
              id="user-manage-email"
            />
            {userEmailError ? this.handleErrorMessage('รูปแบบ email ไม่ถูกต้อง') : null}
            <div className="user-manage-title">เบอร์มือถือ</div>
            <Input
              className="user-manage-input"
              placeholder="ระบุเบอร์ติดต่อ ในรูปแบบ 0812345678"
              onChange={event => this.handleValidateNumber('mobilePhone', event.target.value)}
              onBlur={event => this.handleState('mobilePhone', event.target.value)}
              value={mobilePhone}
              maxLength={10}
              id="user-manage-mobile-phone"
            />
            {mobilePhoneError ? this.handleErrorMessage('กรุณาระบุเบอร์โทร 10 หลัก') : null}
            <div className="user-manage-title">ชื่อผู้ใช้งาน / Username</div>
            <Input
              className="user-manage-input disabled"
              placeholder="ระบุชื่อผู้ใช้งาน ขั้นต่ำ 5 ตัวอักษร"
              value={username}
              disabled
              id="user-manage-username"
            />
            <div className="user-manage-title">สถานะผู้ใช้งาน</div>
            <div className="user-manage-select">
              <Dropdown
                template="a"
                placeholder="เลือกสถานะผู้ใช้งาน"
                valueShow={userDeletedAt ? 'ไม่ใช้งาน' : 'ใช้งาน'}
                ref={this.dropdown}
                id="user-manage-status-dropdown" //TODO: cannot add id
              >
                <div
                  className={`item${userDeletedAt ? '' : ' active'}`}
                  onClick={() => this.handleState('userDeletedAt', null)}
                  id="user-manage-active-choice"
                >
                  ใช้งาน
                </div>
                <div
                  className={`item${userDeletedAt ? ' active' : ''}`}
                  onClick={() => this.handleState('userDeletedAt', new Date().toISOString())}
                  id="user-manage-inactive-choice"
                >
                  ไม่ใช้งาน
                </div>
              </Dropdown>
            </div>
            <div className="user-manage-button-box">
              <Button
                className="btn-primary btn-user"
                onClick={() => this.handleConfirm(commonConstant.userManagementEdit)}
                id="user-manage-edit-btn"
              >บันทึก</Button>
            </div>
          </div>
        );
      case commonConstant.userManagementReset:
        return (
          <div className="user-manage-alert-box reset-box">
            <div className="icon icon-password reset-icon" />
            <div className="user-manage-desc reset-desc">ต้องการตั้งรหัสผ่านใหม่ ?</div>
            <div className="user-manage-remove-user-box">
              <div>User: <span id="user-name">{username}</span></div>
              <div>(<span id="user-role">{userRoles[userRoleID]}</span>)</div>
            </div>
            <div className="user-manage-alert-btn-top-box">
              <div className="user-manage-alert-btn-box">
                <Button
                  className="user-manage-btn first"
                  onClick={handleCloseModal}
                  id="user-manage-close-btn"
                >
                  ยกเลิก
                </Button>
                <Button
                  className="user-manage-btn second"
                  onClick={() => this.handleResetUserPassword(userEdit.userID)}
                  id="user-manage-reset-btn"
                >
                  Reset
                </Button>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  }

  handleAlert = () => {
    const { action, createUser, getUserRoles, resetUserPassword, userEdit } = this.props;
    const { success, userRoles, username, userRoleID } = this.state;

    if (!getUserRoles) {
      return <Loading />;
    }
    if (action === commonConstant.userManagementCreate) {
      if (!createUser.data) {
        return <Loading />;
      }
    } else if (action === commonConstant.userManagementReset) {
      if (!resetUserPassword.data) {
        return <Loading />;
      }
    }

    switch (action) {
      case commonConstant.userManagementCreate:
        return (
          <div className="user-manage-alert-box">
            <div className="icon icon-user-fail success-icon">
              <span className="path1" /><span className="path2"><span className="fa fa-check path-collect" /></span>
            </div>
            <div className="user-manage-desc success-title-desc">เพิ่มผู้ใช้งานสำเร็จ !</div>
            <div className="user-manage-desc">User:
              <span
                className="user-manage-info"
                id="user-manage-username"
              >
                {createUser.data.username}
              </span>
              (<span id="user-manage-role">{userRoles[createUser.data.userRoleID]}</span>)
            </div>
            <div className="user-manage-desc">
              รหัสผ่านครั้งแรกคือ <span className="user-manage-info" id="user-manage-password">{createUser.data.password}</span>
            </div>
            <div className="user-manage-hint">*กรุณาจดรหัสผ่านนี้ ท่านจะไม่สามารถเรียกดูรหัสผ่านนี้ได้อีกครั้ง</div>
            <Button
              className="btn-primary btn-correct"
              onClick={this.handleClearState}
              id="user-manage-confirm-btn"
            >
              ตกลง
            </Button>
          </div>
        );
      case commonConstant.userManagementReset:
        if (success) {
          return (
            <div className="user-manage-alert-box">
              <div className="icon icon-password-success success-icon">
                <span className="path1" /><span className="path2" /><span className="path3" />
              </div>
              <div className="user-manage-desc success-title-desc">ตั้งรหัสผ่านใหม่สำเร็จ !</div>
              <div className="user-manage-desc success-desc">User:
                <span className="user-manage-info" id="user-manage-username">
                  {username}
                </span>
                (<span id="user-manage-role">{userRoles[userRoleID]}</span>)
              </div>
              <div className="user-manage-desc">
                รหัสผ่านใหม่คือ <span className="user-manage-info" id="user-manage-password">{resetUserPassword.data.password}</span>
              </div>
              <div className="user-manage-hint">*กรุณาจดรหัสผ่านนี้ ท่านจะไม่สามารถเรียกดูรหัสผ่านนี้ได้อีกครั้ง</div>
              <Button
                className="btn-primary btn-correct"
                onClick={this.handleClearState}
                id="user-manage-confirm-btn"
              >
                ตกลง
              </Button>
            </div>
          );
        }
        return (
          <div className="user-manage-alert-box reset-box">
            <div className="icon icon-password-fail fail-icon">
              <span className="path1" /><span className="path2"><span className="fa fa-times path-collect" /></span>
            </div>
            <div className="user-manage-desc fail-desc">ตั้งรหัสผ่านใหม่ สำหรับผู้ใช้งาน</div>
            <div className="user-manage-desc fail-desc">
              <span className="user-manage-info" id="user-manage-username">
                {username}
                (<span id="user-manage-role">{userRoles[userRoleID]}</span>)
              </span> ไม่สำเร็จ!</div>
            <div className="user-manage-desc fail-try-desc">กรุณาลองใหม่อีกครั้ง</div>
            <div className="user-manage-alert-btn-top-box">
              <div className="user-manage-alert-btn-box">
                <Button
                  className="user-manage-btn first"
                  onClick={this.handleClearState}
                  id="user-manage-cancel-btn"
                >
                  ยกเลิก
                </Button>
                <Button
                  className="user-manage-btn second"
                  onClick={() => this.handleResetUserPassword(userEdit.userID)}
                  id="user-manage-retry-reset"
                >
                  ลองอีกครั้ง
                </Button>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  }

  handleClearState = () => {
    const { handleCloseModal, resetUserPassword } = this.props;

    if (resetUserPassword.data) {
      this.props.dispatch(clearResetUserPassword());
    }

    this.setState({
      'success': false, 'userRole': null, 'name': '', 'userEmail': '',
      'mobilePhone': '', 'username': '', 'userRoleID': '', 'userDeletedAt': null,
    });
    return handleCloseModal();
  }

  handleState = (state, val, extra) => {
    switch (state) {
      case 'name':
        if (validateAlpha(val)) {
          return this.setState({ 'name': val, 'nameError': false });
        }
        return false;
      case 'userEmail':
        if (validateEmail(val) || val.length === 0) {
          return this.setState({ 'userEmail': val, 'userEmailError': false });
        }
        return this.setState({ 'userEmail': val, 'userEmailError': true });
      case 'mobilePhone':
        if (validateTelNumber(val)) {
          return this.setState({ 'mobilePhone': val, 'mobilePhoneError': false });
        }
        return this.setState({ 'mobilePhoneError': true });
      case 'userRole':
        this.dropdown.current.handleShowItem();
        return this.setState({ 'userRole': val, 'userRoleError': false, 'userRoleID': extra });
      case 'username':
        if (validateUsername(val)) {
          if (val.length > 4) {
            return this.setState({ 'username': val, 'usernameError': false, 'usernameExist': false });
          }
          return this.setState({ 'username': val, 'usernameError': true });
        }
        return false;
      case 'userDeletedAt':
        this.dropdown.current.handleShowItem();
        return this.setState({ 'userDeletedAt': val });
      default:
        return false;
    }
  }

  handleValidateNumber = (state, val) => validateNumber(val) ? this.setState({ [state]: val }) : null;

  handleErrorMessage = message => <div className="in-valid">{message}</div>;

  handleConfirm = type => {
    const { getBuildingByRefNo, userEdit } = this.props;
    const { username, name, mobilePhone, userEmail, userEmailError, userRole, userRoleID, mobilePhoneError, userDeletedAt } = this.state;

    if (userEmail && userEmailError) {
      return this.setState({ 'userEmailError': true });
    }
    if (username && name && mobilePhone && userRole && userRoleID && !mobilePhoneError && !userEmailError && type === commonConstant.userManagementCreate) {
      return this.props.dispatch(fetchCreateUser(buildingID(getBuildingByRefNo), userRoleID, username, name, mobilePhone, userEmail ? userEmail : null));
    }
    if (name && mobilePhone && !mobilePhoneError && !userEmailError && type === commonConstant.userManagementEdit) {
      return this.props.dispatch(fetchUpdateUser(userEdit.userID, name, mobilePhone, userEmail ? userEmail : null, userDeletedAt));
    }
    if (!username) {
      this.setState({ 'usernameError': true });
    }
    if (!name) {
      this.setState({ 'nameError': true });
    }
    if (!mobilePhone) {
      this.setState({ 'mobilePhoneError': true });
    }
    if (!userRole) {
      this.setState({ 'userRoleError': true });
    }
  }

  render() {
    const { success, resetPassword } = this.state;
    const { show, handleCloseModal, getUserRoles } = this.props;

    return (
      <Modal show={show ? true : false} header={this.handleHeaderModal()} handleToggle={handleCloseModal}>
        {!getUserRoles ? <Loading /> : null}
        <div className="UserManage">
          {
            success || resetPassword ? this.handleAlert() : this.handleBodyModal()
          }
        </div>
      </Modal>
    );
  }
}

UserManage.propTypes = {
  'show': PropTypes.bool,
  'handleCloseModal': PropTypes.func,
  'action': PropTypes.string,
  'dispatch': PropTypes.func,
  'getUserRoles': PropTypes.array,
  'createUser': PropTypes.shape({
    'status': PropTypes.number,
    'type': PropTypes.string,
    'data': PropTypes.shape({
      'reason': PropTypes.string,
      'userProfile': PropTypes.string,
      'userRoleID': PropTypes.string,
      'password': PropTypes.string,
      'username': PropTypes.string,
    }),
  }),
  'getBuildingByRefNo': PropTypes.object,
  'userEdit': PropTypes.object,
  'updateUser': PropTypes.shape({
    'status': PropTypes.number,
    'data': PropTypes.object,
    'type': PropTypes.string,
  }),
  'resetUserPassword': PropTypes.object,
};

const mapStateToProps = ({ getUserRoles, createUser, getBuildingByRefNo, updateUser, resetUserPassword }) => ({
  'getUserRoles': getUserRoles.data,
  createUser,
  'getBuildingByRefNo': getBuildingByRefNo.data,
  updateUser,
  resetUserPassword,
});

export default connect(mapStateToProps)(UserManage);
